import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
export var api__getFeedbackList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var page,
      res,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          page = _args.length > 0 && _args[0] !== undefined ? _args[0] : 1;
          _context.n = 1;
          return fetcher().get("/site/feedback-list?page=".concat(page));
        case 1:
          res = _context.v;
          return _context.a(2, res.data.data);
      }
    }, _callee);
  }));
  return function api__getFeedbackList() {
    return _ref.apply(this, arguments);
  };
}();